import { openPositions } from "../modules/open-positions";

const careersPage = (gsap, mm, ScrollTrigger, smoother, imagesLoaded, Swiper, Parallax, Navigation, Pagination, FreeMode) => {
  
  /***************************************************************
    PARALLAX ITEMS
  ***************************************************************/
 
  const $heroImgs = $('.bg-images img');
  const $heroImgOne = $('.bg-images .img-one');
  const $heroImgTwo = $('.bg-images .img-two');
  const $careerAboutText = $('.career-about-copy')
  const $valuesText = $('.careers-values .p-sm');
  const $programs = $('.program-row .program');
  
  //$('.careers-intro').imagesLoaded( function() {
  //  gsap.to($heroImgs, {duration: 0.6, autoAlpha: 1});
  //  // Update scroll position to account for negative margins
  //  //smoother.paused(true);
  //  //smoother.paused(false);
  //  ScrollTrigger.refresh(true);
  //});
  
  //mm.add("(min-width: 1280px)", () => {
  //  smoother.effects($careerAboutText, {speed: 1.05});
  //}, '.page-careers');
  
  mm.add("(min-width: 992px)", () => {
    smoother.effects($valuesText, {speed: 1.2, lag: 0});

    $programs.each(function() {

      const $this = $(this);
      const $map = $(this).find('feDisplacementMap');

      $this.on('mouseenter', function() {
        gsap.to($map, { duration: 0.6, attr: { scale: 40} });
      }).on('mouseleave', function() {
        gsap.to($map, { duration: 0.6, attr: { scale: 0} });
      });

    });
  }, '.page-careers');
  
  //mm.add("(min-width: 768px)", () => {
  //  smoother.effects($heroImgOne, {speed: 1.8});
  //}, '.page-careers');
  
  //smoother.effects($heroImgTwo, {speed: 1.2});
  
  const $offices = $('.comp__locations .location');

  $offices.each(function(index, el) {
    smoother.effects(el, {lag: 0.3 + index * 0.1});
  });
  
  /***************************************************************
    TEAM CAROUSEL
  ***************************************************************/

  // Setup Featured Team Slides
  //const $teamSlides = $('.careersTeam .team-slide');
  //const maxTeamSlides = $teamSlides.length;
  //let curTeamSlide = 0;

  //if (maxTeamSlides > 0) {
  //  // Init slides
  //  changeTeamSlide(0);

  //  // Clicking Prev
  //  $('.careersTeam .team-nav .team-prev').on('click', () => {
  //    changeTeamSlide(-1);
  //  });
  
  //  // Clicking Next
  //  $('.careersTeam .team-nav .team-next').on('click', () => {
  //    changeTeamSlide(1);
  //  });
  //}

  //// Handles Slide Change
  //function changeTeamSlide (changeBy) {
  //  curTeamSlide += changeBy;
  //  curTeamSlide = Math.min(Math.max(curTeamSlide, 0), maxTeamSlides - 1);


  //  // Set new classes for slides
  //  $teamSlides.each((idx, el) => {
  //    const $this = $(el);
  //    // Previous Slide
  //    if (idx < curTeamSlide){
  //      $this.addClass('prev').removeClass('current next');
  //      pauseVideo($this);
  //    }
  //    // Next Slide
  //    else if (idx > curTeamSlide){
  //      $this.addClass('next').removeClass('current prev');
  //      updateImagePositioning($this, idx);
  //      pauseVideo($this);
  //    }
  //    // Current Slide
  //    else {
  //      $this.addClass('current').removeClass('next prev');
  //    }
  //  });



  //  // Adjust pagination text
  //  $('.careersTeam .team-pagination')[0].innerHTML = 
  //    `${curTeamSlide + 1} / ${maxTeamSlides}`;
  //}

  //// Transform images
  //function updateImagePositioning($slide, idx) {
  //  const imgPosX = (((curTeamSlide - idx - 1) % 3)) * 10 + 10;
  //  const imgPosY = (idx-curTeamSlide) * 10;
  //  $slide.find('.img').css("transform", `translate(${imgPosX}px, ${imgPosY}px)`);
  //}

  //// Pause video if availible
  //function pauseVideo($slide) {
  //  const hash = $slide.find('.video-hash').data('hash');
  //  const video = hash && window.Wistia ? Wistia.api(hash) : null;
  //  if (video && video.state() === "playing"){
  //    video.pause();
  //  }
  //}

  /***************************************************************
    HIRING BLOCK
  ***************************************************************/
 
  openPositions(gsap);
    
}


  /***************************************************************
    ULTIMATE TEST
  ***************************************************************/

  //const answerBoxes = $('.answer-box');

	//$(window).resize(function() {
	//	resetBoxes();
	//});

	//$('.answer-box').mousemove(function (e) {
	//	$('.cursor', this).show().css({ left: e.pageX, top: e.pageY });
	//});

	//$('.answer-box').mouseout(function (e) {
	//	$('.cursor', this).hide();
	//});

	//$('.answer-box').click(function (e) {
	//	var answerColor = $(this).data('answer-color');
	//	resetBoxes();

	//	// animate width of boxes
	//	$(answerBoxes).each(function() {
	//		var answerBox = $(this);
	//		var answerText = $(this).find('.answer-text');

	//		if ($(window).width() < 656) {
	//				var answerHeight = answerBox.height() * 2;
	//				var floatPercentage = parseFloat(answerBox.data('percentage')) / 100;
	//				var newHeight = answerHeight * floatPercentage;
	//				answerBox.animate({ height: newHeight }, 500);
	//				answerText.animate({ height: newHeight });
	//		} else {
	//			$(this).animate({ flexBasis: $(this).data('percentage') }, 500);
	//		}
	//	});

	//	// fade out cursor, activate bgcolor, and show answer details
	//	$('.cursor', this).fadeOut();
	//	$(this).addClass('selected').css({ backgroundColor: answerColor });
	//	$('.answer-details',this).delay(100).animate({opacity: 1}, 200);
	//});

	//function resetBoxes() {
	//	// reset boxes on each click
	//	$('.answer-box').css({ backgroundColor: '', height: '', flexBasis: '' });
	//	$('.answer-text').css({ height: '' });
	//	$('.answer-details').css({ opacity: 0 });
	//}

export {
  careersPage
};
